<template>
  <font-awesome-icon
    :icon="
      state.order[field] && state.order[field] == 'asc'
        ? 'chevron-up'
        : 'chevron-down'
    "
  />
</template>

<script>
import { state, gettersMap, mutationsMap } from "store/table.js";
export default {
  props: ["field"],
  data: () => ({
    state: state,
  }),
};
</script>
